import { Injectable, Inject } from '@angular/core';

import { ConfigurationsService } from '../configurations.service';
import { map, tap } from 'rxjs/operators';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared/config';
import { TaxRatesService } from '@icc/b2b/shared';

@Injectable()
export class ConfiguratorFacade {
    constructor(
        private configurationsService: ConfigurationsService,
        @Inject(APP_CONFIG) private config: AppConfigFactory,
    ) {}

    price$ = this.configurationsService.configuration$.pipe(
        map((conf) => ({
            showPrice: (this.config().preset !== 'b2c' || !this.config().hidePricesInB2cConfigurator) && (conf.type !== 'external_venetian' || conf.shutters.length > 0),
            priceBeforePromotions: conf.PriceAfterMultiplier,
            price: conf.Price,
            priceAfterDiscounts: conf.PriceAfterDiscounts,
            discount: 0,
            hasGrossPrice: conf.PriceIsGross,
            promotion: Math.abs(conf.PriceAfterMultiplier - conf.Price) > 2000 * Number.EPSILON ?
                conf.PriceAfterMultiplier - conf.PriceAfterDiscounts : 0,
            extraProductsPrice: conf.selectedProducts ? (Object.entries(conf.selectedProducts) as [string, {
                price: number;
                isGross: boolean;
                taxRate: number;
                currency: string;
                unitName: string;
                unitCode?: string;
                unitSymbol: string;
                unitId: number;
            }][]).reduce<number>((acc, curr) => {
                if (Number(conf.fields[curr[0] + '_qty']?.value) > 0) {
                    return acc + TaxRatesService.recalcPrice(
                        conf.PriceIsGross,
                        curr[1].price,
                        curr[1].isGross,
                        curr[1].taxRate,
                        conf.PriceTaxRate
                    ) * (conf.fields[curr[0] + '_qty']?.value ?? 1);
                } else {
                    return acc;
                }
            }, 0) : 0,
            extraProductsPriceBeforePromotion: conf.selectedProducts ? (Object.entries(conf.selectedProducts) as [string, {
                price: number;
                priceBeforePromotion: number;
                isGross: boolean;
                taxRate: number;
                currency: string;
                unitName: string;
                unitCode?: string;
                unitSymbol: string;
                unitId: number;
            }][]).reduce<number>((acc, curr) => {
                if (Number(conf.fields[curr[0] + '_qty']?.value) > 0) {
                    return acc + TaxRatesService.recalcPrice(
                        conf.PriceIsGross,
                        curr[1].priceBeforePromotion,
                        curr[1].isGross,
                        curr[1].taxRate,
                        conf.PriceTaxRate
                    ) * (conf.fields[curr[0] + '_qty']?.value ?? 1);
                } else {
                    return acc;
                }
            }, 0) : 0,
        }))
    );
    issues$ = this.configurationsService.configuration$.pipe(map((conf) => conf.Issues));
}
